// WORKER
export const SET_CERTIFICATE_DATA = "SET_CERTIFICATE_DATA";